// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__g3Sxb","addWidgetButton":"Header_addWidgetButton__35cmm","dashboardTabs":"Header_dashboardTabs__1Of_8","active":"Header_active__2leDc"};